import { useCallback, useEffect, useRef } from 'react'

const useDebounceCallback = (callback, delay) => {
  const timerRef = useRef(null)
  const callbackRef = useRef(callback)

  callbackRef.current = callback

  useEffect(() => () => clearTimeout(timerRef.current), [])

  return useCallback(() => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => callbackRef.current(), delay)
  }, [delay])
}

export default useDebounceCallback
